import { type WithT } from "i18next";
import { useTranslation } from "react-i18next";
import { getXmlConfiguratorTranslationConfig } from "~/domains/configurator/translations/configuratorTranslationConfig";
import { getConfiguratorFamilyFromProductCode } from "~/domains/configurator/types/ConfiguratorType";

export const useConfiguratorTranslations = (productCode: string) => {
  const config = getXmlConfiguratorTranslationConfig(productCode);
  const configuratorFamily = getConfiguratorFamilyFromProductCode(productCode);
  const { t: originalT } = useTranslation(config?.sheetName);

  if (!config) {
    return { t: undefined, tPrefix: undefined };
  }

  const t = ((key: string, options?: object) =>
    originalT(key, { context: configuratorFamily, ...options })) as WithT["t"];

  return { t, tPrefix: config.tPrefix };
};
